<script setup>
import DashboardStatsUserCard from '@/Components/Dashboard/DashboardStatsUserCard'
import InvoiceIcon from '@/icons/InvoiceIcon'
import PayInvoiceButton from '@/Components/Models/Invoice/PayInvoiceButton.vue';
import { formatDate } from '@/Mixins/FormatsDates'

import { ref, onMounted, computed } from 'vue'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const props = defineProps({
	organisation: {
		type: Object,
		default: null,
	},
})

// is the DueDate in the past?
const overDue = computed(() => {
	if (props.organisation === null) return false
	return new Date(props.organisation.next_invoice_due_date) < new Date()
})

//helper function to format large numbers
function formatNum(val){
	let price = parseInt(val)
	let formatted = price.toLocaleString("en-US")
	return formatted.split('.')[0]	
}

const hasFetched = ref(false)
const invoice = ref(null)
function fetchInvoice() {
	hasFetched.value = false
    return axios.get('/api/invoices/organisation/' + props.organisation.id + '/next')
    .then(response => {
        invoice.value = response.data
    })
    .catch(error => {
        errors.push({
			type: 'error',
			title: 'Error fetching invoice',
            message: error.response.data.message,
        })
    })
	.finally(() => {
		hasFetched.value = true
	})
}

onMounted(() => {
	fetchInvoice()
})

</script>
<template>
	<BlockLoader class="h-64 w-full" v-if="!hasFetched" />

	<DashboardStatsUserCard v-else :icon="InvoiceIcon">

		<div class="text-center" v-if="!!invoice">
			<p class=" text-3xl">${{formatNum(invoice.AmountDue)}}</p>
			<span v-if="overDue" class=" bg-Red text-white text-[10px] px-2 py-1 rounded-xl ">OVERDUE</span>
			<p class="text-sm" >Invoice due <span class="font-medium">{{ formatDate(invoice.DueDate) }}</span></p>
			<div class="flex mt-4 justify-center">
				<PayInvoiceButton
					v-if="auth.can('make_payments') && !auth.isAdmin"
					:invoice="invoice"
					cardable_type="organisation"
					:cardable_id="props.organisation.id"
				/>
			</div>
		</div>

		<div v-if="!invoice">
			<p class="text-center pt-4">No invoices due</p>
		</div>

		<template #footer>
			<!-- link to invoice page -->
			<Button
				color="blue"
				variant="link"
				href="/invoices"
			>
				View All Invoices
			</Button>
		</template>

	</DashboardStatsUserCard>

</template>